// extracted by mini-css-extract-plugin
export default {"title":"q9j7oqT3"};